import styled, {
  boxShadows,
  BoxShadows,
  breakpoints,
  Device,
  falconTheme,
  IFalconTheme,
  ResponsiveTypographyVariant,
  Scale,
  StyledComponent,
  typographyVariantProperties,
} from '@se-admin/falcon';
import { Color } from '../../../common/types/color';
import { IDiscountBadge } from '../DiscountBadge.interfaces';

export const DiscountBadgeContainer: StyledComponent<'div', IFalconTheme, {}> = styled('div')`
  display: inline-flex;
  background: ${({ theme }) => theme.color.white};
  border: 1px solid ${Color.red};
  border-radius: ${Scale.xxs};
  box-shadow: ${boxShadows[BoxShadows.level1]};
  font-family: ${({ theme }) => theme.fontFamilyHead.join(',')};
  padding: 6px ${Scale.s};
`;

DiscountBadgeContainer.defaultProps = { theme: falconTheme };
DiscountBadgeContainer.displayName = 'DiscountBadgeContainer';

export const TextWrapper: StyledComponent<'div', {}, Partial<IDiscountBadge>> = styled('div')`
  color: ${Color.red};
  position: relative;
  text-align: center;
  .discount-price {
    font-size: ${typographyVariantProperties[ResponsiveTypographyVariant.t4Sans].mobileFontSize};
    display: block;
    font-weight: 700;
    line-height: 1;
    margin-top: ${Scale.xxxs};
    @media (min-width: ${breakpoints[Device.tablet]}) {
      font-size: ${typographyVariantProperties[ResponsiveTypographyVariant.t4Sans].tabletFontSize};
    }
    @media (min-width: ${breakpoints[Device.desktop]}) {
      font-size: ${typographyVariantProperties[ResponsiveTypographyVariant.t4Sans].desktopFontSize};
    }
  }
`;

TextWrapper.displayName = 'TextWrapper';

export const TooltipStyle: StyledComponent<'div', {}, {}> = styled('div')`
  bottom: -${Scale.xxs};
  font-style: normal;
  position: absolute;
  right: 0px;
`;

TooltipStyle.displayName = 'TooltipStyle';

export const TooltipContainer: StyledComponent<'span', {}, {}> = styled('span')`
  margin-left: ${Scale.xxs};
`;

TooltipContainer.displayName = 'TooltipContainer';
